/* Remember to align this with the css version \src\3rd-party\libraries\bootstrap */
export var BREAKPOINTS = {
    xs: 0,
    sm: 420,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
